import {CommonService} from '../../../services/common.service';
import {Component, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {LoadingService} from '../../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UsersService} from '../../../services/users.service';
import {ActionCompletionDialogComponent} from '../../../common/action-completion-dialog/action-completion-dialog.component';

@Component({
  templateUrl: './edit-user-dialog.component.html'
})
export class EditUserDialogComponent {
  public hasChildren: boolean;
  public roles: any[];
  public salesGroups: any[];
  public userBasicForm: FormGroup;
  private readonly user: any;
  public users: any[];
  public regions: any[];
  public divisions: any[];

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<EditUserDialogComponent>,
              public usersService: UsersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.hasChildren = this.data.hasChildren;

    this.roles = this.data.roles;

    this.salesGroups = this.data.salesGroups;

    this.user = this.data.user;
    this.regions = this.data.regions;
    this.divisions = this.data.divisions;
    for (const division of this.divisions) {
      division.id = division.id.toString();
    }

    this.userBasicForm = this.usersService.initializeUserBasicForm(this.roles, this.user);

    this.users = this.data.users;
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public submitUser(): void {
    this.matDialogRef.close();

    const draftUser = this.usersService.submitUser(this.userBasicForm, this.user);

    const uniqueSalesGroups = [];

    if (draftUser.hasOwnProperty('salesGroups')) {
      for (let i = 0; i < draftUser.salesGroups.length; i++) {
        if (uniqueSalesGroups.indexOf(draftUser.salesGroups[i]) === -1) {
          uniqueSalesGroups.push(draftUser.salesGroups[i]);
        }
      }

      draftUser.salesGroups = uniqueSalesGroups;
    }
    this.commonService.updateObject('user', draftUser).then(() => {
      this.loadingService.hide();

      this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
    });
  }
}
